import React, { useState, useEffect } from "react";
import { Table, Typography } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Pageloader from "../../components/loader";
import { validationErrors } from "../../utils/Helpers";
import * as workActions from "../../redux/actions/work.actions";
import { Tag } from "antd";
import WorkFilters from "./ItemLevelInventoryFilters";
import moment from "moment";

const { Text, Title } = Typography;

const ItemLevelInventory = ({ workActions, workData, workPagination, zoneData }) => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const [filters, setFilters] = useState({
    orderCreationDate: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
  });

  const fetchWorkList = async (extraFilters = {}) => {
    try {
      setLoading(true);

      const finalFilters = {
        ...filters, // always use current filters
        page: extraFilters.page || currentPage,
        limit: extraFilters.limit || currentPageSize,
        ...extraFilters,
      };

      await workActions.ItemLevelInventoryFiltersPagination(finalFilters);
      setFilters(finalFilters); // update filters in state
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };
  
  // Load initial data once
  // useEffect(() => {
  //   fetchWorkList(filters);
  // }, []);

  // Only re-fetch when page/size changes (keep filters intact)
  useEffect(() => {
    fetchWorkList({ page: currentPage, limit: currentPageSize });
  }, [currentPage, currentPageSize]);

  const workColumns = [
    {
      title: "Store ID",
      dataIndex: "store_id",
      key: "store_id",
      render: (text) => text || "-",
    },
    {
      title: "Parent Sku",
      dataIndex: "parent_sku",
      key: "parent_sku",
      render: (text) => text || "-",
    },
    {
      title: "Configuration",
      dataIndex: "configuration",
      key: "configuration",
      render: (text) => text || "-",
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
      render: (text) => text || "-",
    },
  ];

  return (
    <div className="page-content">
      <div className="page-content-header" style={{ display: "flex", justifyContent: "space-between" }}>
        <Title level={2}>Item Level Inventory</Title>
      </div>
      {/* {JSON.stringify(workData)} */}
      {/* Filters Section */}
      <div className="p-content">
        <WorkFilters onFilterChange={fetchWorkList} />
        {loading ? (
          <Pageloader />
        ) : (
          <Table
            className="tablehover"
            dataSource={workData || []}
            columns={workColumns}
            rowKey="_id"
            pagination={{
              total: workPagination?.total || 0,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total}`,
              current: currentPage,
              pageSize: currentPageSize,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30", "50", "100"],
              onChange: (page, size) => {
                setCurrentPage(page);
                setCurrentPageSize(size);
              },
            }}
            onRow={(record) => ({
              onDoubleClick: () => window.open(`/works/${record.workId}`),
            })}
          />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  workData: state.WorkReducer.workData,
  workPagination: state.WorkReducer.workPagination,
  zoneData: state.ZoneReducer.zoneData,
});

const mapDispatchToProps = (dispatch) => ({
  workActions: bindActionCreators(workActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLevelInventory);
